import hrms41eLabels from 'assets/labels/hrms41e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms41eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        dteappoi: moment().format('DD/MM/YYYY'),
        numtmapp: moment().format('hh:mm:ss'),
        numreqrq: faker.random.number().toString().substr(0, 1),
        numapseq: faker.random.number().toString().substr(0, 1),
        numappl: faker.random.number().toString().substr(0, 1),
        desc_numappl: faker.name.findName(),
        codposrq: faker.random.number().toString().substr(0, 5),
        desc_codposrq: faker.lorem.word(),
        stapphinv: '',
        desc_stapphinv: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codform: faker.random.number().toString().substr(0, 1),
      desc_codform: faker.lorem.word(),
      stapphinv: '',
      desc_stapphinv: faker.lorem.word(),
      desnote: faker.lorem.word(),
      qtyscor: faker.random.number().toString().substr(0, 1),
      desc_qtyscor: faker.lorem.word()
    }
    let mockTab1Table2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockTab1Table2Total = 4
    for (var d = 1; d <= mockTab1Table2Total; d++) {
      mockTab1Table2Rows.push({
        grditem: d,
        grad: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        desc_grditem: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockTab1Table1GroupRows = []
    const mockTab1Table1Total = 3
    for (var a = 1; a <= mockTab1Table1Total; a++) {
      let mockTab1Table1ItemRows = []
      const mockTab1Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab1Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGrditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGrditem * mockItemQtywgt
        let mockChoiceFiltered = mockTab1Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGrditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grad
        }
        mockTab1Table1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          definit: 'Sub description',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          grditem: mockItemGrditem,
          grad: mockGrad,
          qtywgt: mockItemQtywgt,
          descomment: faker.lorem.word()
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab1Table1GroupRows.push({
        numgrup: a,
        desgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockTab1Table1ItemRows
      })
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        numappl: faker.random.number().toString().substr(0, 1),
        desc_numappl: faker.lorem.word(),
        numreqrq: faker.random.number().toString().substr(0, 1),
        codposrq: faker.random.number().toString().substr(0, 1),
        desc_codposrq: faker.lorem.word(),
        stapphinv: faker.random.number().toString().substr(0, 1),
        desc_stapphinv: faker.lorem.word(),
        dteappoi: moment().format('DD/MM/YYYY'),
        dteappr: moment().format('DD/MM/YYYY'),
        codappr: faker.random.number().toString().substr(0, 1),
        desc_codappr: faker.name.findName(),
        numapseq: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      tab1: {
        detail: mockTab1,
        table1: {
          total: mockTab1Table1Total,
          rows: mockTab1Table1GroupRows
        },
        table2: {
          total: mockTab1Table2Total,
          rows: mockTab1Table2Rows
        }
      },
      tab2: {
        total: mockTab2Total,
        rows: mockTab2Rows
      }
    }
  },
  indexCancel () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms41e/mocker.js